export const formatDisplayName = (text = '', maxLength = 20, maxWords = 3) => {
  if (!text) return '';

  const words = text.trim().split(/\s+/);

  if (words.length > maxWords) {
    const sliced = words.slice(0, maxWords).join(' ');
    return sliced.length > maxLength
      ? sliced.slice(0, maxLength) + '...'
      : sliced + '...';
  }

  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};
